<div class="w-full flex flex-col gap-10 mb-10 mt-10">
    <section
        class="flex flex-row items-center justify-center mx-auto w-full md:w-6/12 xl:w-4/12"
    >
        <button
            mat-button
            mat-raised-button
            color="primary"
            type="button"
            class="w-full !rounded-lg"
            [disabled]="disableSubmission"
            (click)="handleSubmit()"
        >
            {{ submitButtonLabel }}
        </button>
    </section>
    @if (showDisclaimer) {
        <section class="w-full">
            <div class="flex flex-row space-x-2 items-center">
                <img
                    title="Disclaimer"
                    class="h-5"
                    alt="info icon"
                    [src]="'assets/svg/info-icon-circle-blue.svg'"
                />
                <span class="text-tertiary-900 !text-xs"
                    >I understand that if the application cannot be processed
                    due either to missing data or inconsistencies with
                    applicable FCC Rules, EWA will contact me with
                    recommendations on how best to proceed. Should I request EWA
                    to amend the application so that it may be processed and
                    submitted to the FCC in conformance with their rules,
                    application preparation fees will apply, in addition to
                    frequency coordination and FCC filing fees. A fee will be
                    incurred if the application is withdrawn.</span
                >
            </div>
        </section>
    }
</div>
